import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { SocialLogin } from './SocialLogin';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { INSTAGRAM_FACEBOOK_UPGRADE_PROVIDER } from '../../utils/instagramOAuthProvider';

/**
 * Prompt + Connect with Facebook for Instagram publish / automation.
 */
export function FacebookUpgradeConnect({
    onCodeReceived,
    onAuthComplete,
    compact = false,
    authBaseUrl,
}: {
    onCodeReceived: (code: string) => void;
    onAuthComplete?: (ok: boolean) => void;
    compact?: boolean;
    /** Brand flows should pass brand-auth base URL. */
    authBaseUrl?: string;
}) {
    return (
        <Box
            sx={{
                p: compact ? 1.25 : 2,
                borderRadius: 2,
                bgcolor: 'rgba(255,201,101,0.08)',
                border: '1px solid rgba(255,201,101,0.28)',
            }}>
            <Typography
                sx={{
                    fontSize: compact ? 12 : 13,
                    color: 'rgba(255,255,255,0.85)',
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    lineHeight: 1.45,
                    mb: 1.25,
                }}>
                Publishing and automation need a Facebook connection. Your Instagram account is already linked for
                verification — connect Facebook to unlock this.
            </Typography>
            <SocialLogin
                provider={INSTAGRAM_FACEBOOK_UPGRADE_PROVIDER}
                authBaseUrl={authBaseUrl}
                onCodeReceived={onCodeReceived}
                onAuthComplete={onAuthComplete}
                customButton={
                    <Button
                        size="small"
                        sx={{
                            fontSize: 12,
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                            color: '#392700',
                            bgcolor: '#ffc965',
                            borderRadius: 999,
                            px: 2,
                            py: 0.75,
                            textTransform: 'none',
                            '&:hover': { filter: 'brightness(1.05)' },
                        }}>
                        Connect with Facebook
                    </Button>
                }
            />
        </Box>
    );
}
